import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  LinearProgress,
} from "@mui/material";
import { Icon } from "@mui/material";

import React from "react";

interface Props {
  open: boolean;
  item: string;
  handleClose: () => void;
  handleDelete: () => void;
  isDeleting: boolean
}

const DeleteProductCategoryDialog = (props: Props) => {
  const { open, item, handleClose, handleDelete, isDeleting } = props;

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      scroll="body"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        Delete Category
        <IconButton
          size="small"
          onClick={handleClose}
          sx={{ position: "absolute", right: "1rem", top: "1rem" }}
        >
          <Icon>close</Icon>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography textAlign="center">
          Are you sure you want this delete category?
        </Typography>
        <Typography textAlign="center" color="error" fontWeight={700}>
          {item}
        </Typography>
      </DialogContent>

      {isDeleting && <LinearProgress />}

      <DialogActions>
        <Button
          size="large"
          type="submit"
          sx={{ mr: 2 }}
          variant="contained"
          onClick={handleDelete}
        >
          Yes
        </Button>
        <Button
          size="large"
          color="secondary"
          variant="outlined"
          onClick={handleClose}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteProductCategoryDialog
